module.exports = __webpack_public_path__ + "0a5414662771ff333d25c42d0e5dd2b2.svg";